import type { Space } from '@cocoonspace/sdk-js/types/space'
import { Card } from '@cocoonspace/ui/components/card'
import {
	MapCn,
	MapMarker,
	MarkerContent,
} from '@cocoonspace/ui/components/map-cn/map'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
	PopoveArrow,
} from '@cocoonspace/ui/components/popover'
import { MapPinIcon } from 'lucide-react'

export const CartSheetSpaceMap = ({ space }: { space: NonNullable<Space> }) => (
	<Popover>
		<PopoverTrigger asChild>
			<button
				type='button'
				title={`${space.address.address1} ${space.address.postal_code}`}
				className='flex items-center gap-1 truncate text-xs hover:underline'
			>
				<MapPinIcon className='!size-3 !shrink-0' />

				<span className='truncate'>
					{space.address.address1} {space.address.postal_code}
				</span>
			</button>
		</PopoverTrigger>

		<PopoverContent
			side='left'
			sideOffset={73}
			className='h-[300px] w-[500px] overflow-hidden rounded-lg p-1.5 max-sm:hidden'
			style={{ background: 'linear-gradient(90deg, #ff6a00, #ee0979)' }}
		>
			<PopoveArrow
				className='fill-[#ee0979]'
				width={16}
				height={8}
			/>

			<Card className='h-full w-full overflow-hidden rounded-md'>
				<MapCn
					center={[space.longitude, space.latitude]}
					zoom={14}
					attributionControl={false}
					className='h-full w-full'
				>
					<MapMarker
						latitude={space.latitude}
						longitude={space.longitude}
					>
						<MarkerContent>
							<MapPinIcon className='fill-primary !size-8 text-white' />
						</MarkerContent>
					</MapMarker>
				</MapCn>
			</Card>
		</PopoverContent>
	</Popover>
)
